import { partition } from 'lodash';

import * as Quotes from '#/unified-rfqs/ui/rfqs/quotes-functions';

import { GrfqQuote } from '#/unified-rfqs/entities/grfq/domain';
import { MyQuoteItem, TableQuoteItem } from '#/unified-rfqs/ui/types';

export interface QuotesTableView {
  readonly asks: QuotesTable;
  readonly bids: QuotesTable;
}

interface QuotesTable {
  readonly quotes: readonly TableQuoteItem[];
  readonly myQuotes: MyQuoteItem[];
}

interface QuoteTableViewArgs {
  readonly myDesk: string;
  readonly bidQuotes: readonly GrfqQuote[];
  readonly askQuotes: readonly GrfqQuote[];
}

export default function quotesTableView({
  myDesk,
  bidQuotes,
  askQuotes,
}: QuoteTableViewArgs): QuotesTableView {
  return {
    bids: processQuotesTable(myDesk, bidQuotes),
    asks: processQuotesTable(myDesk, askQuotes),
  };
}

function processQuotesTable(
  myDesk: string,
  quotes: readonly GrfqQuote[],
): QuotesTable {
  const partitionByDesk = (quote: GrfqQuote) => Quotes.isMine(quote, myDesk);
  const [myQuotes] = partition(quotes, partitionByDesk);

  return {
    myQuotes: Quotes.processMyQuotes(myQuotes),
    quotes: Quotes.processAggregatedQuotes(quotes),
  };
}
